import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    nav: {
      home: 'Home',
      catalog: 'Villas',
      contact: 'Contact',
      admin: 'Admin',
    },
    hero: {
      subtitle: 'Luxury Villas for Sale in Croatia',
      title: 'Buy Seafront Villa in Croatia',
      description: 'Looking to buy a beachfront villa in Croatia? We offer luxury villas for sale directly from the developer — no hidden fees. Houses for sale in Dalmatia region.',
      cta: 'View Villas for Sale',
      ctaSecondary: 'WhatsApp Us',
    },
    about: {
      label: 'About Us',
      title: 'Buy a Villa in Croatia — Your Dream Home Awaits',
      description: 'Looking for houses for sale in Croatia? Our luxury villas for sale stand in rare seafront locations, blending contemporary architecture with the prestige of a prime coastal setting. Buy a seafront villa in Croatia directly from the developer. Every villa enjoys a true beachfront position, offering an exceptional lifestyle and strong investment appeal.',
      feature1: 'Best Offers',
      feature2: 'Confirmed Quality',
      feature3: 'Legal Support',
    },
    villas: {
      label: 'Villas for Sale',
      title: 'Luxury Villas for Sale in Croatia',
      viewAll: 'View All',
      bedrooms: 'bedrooms',
      bathrooms: 'bathrooms',
      area: 'm²',
      details: 'Details',
      noVillas: 'Villas coming soon',
    },
    contact: {
      label: 'Contact',
      title: 'Get in Touch',
      description: 'Want to buy a villa in Croatia? Have questions about our houses for sale? We will gladly help!',
      name: 'Your Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send Request',
      success: 'Request Sent!',
      successDesc: 'We will contact you shortly',
    },
    footer: {
      rights: 'All rights reserved',
      privacy: 'Privacy Policy',
      seoText: 'Buy villa in Croatia | Villas for sale in Croatia | Luxury beachfront properties | Houses for sale in Dalmatia',
    },
    features: {
      bestOffers: 'Best Offers',
      bestOffersDesc: 'We offer brilliant quality villas made of natural materials with the highest energy efficiency rating',
      quality: 'Confirmed Quality',
      qualityDesc: 'You receive full design documentation for complete confidence in the quality of design and work',
      saveMoney: 'Save Money',
      saveMoneyDesc: 'Buy a villa in Croatia directly from the developer at a fair price without hidden fees',
      bestPrice: 'Best Villas for Best Price',
      bestPriceDesc: 'Looking for luxury villas for sale in Croatia? All our villas are located on the 1st line',
      legalSupport: 'Legal Support',
      legalSupportDesc: 'We guarantee absolute transparency and full compliance with EU rules and regulations',
      businessGain: 'Business Gain',
      businessGainDesc: 'Villa can be rented out and provide high income. The price of the villa will rise',
    },
    catalog: {
      title: 'Villa Catalog',
      subtitle: 'Find your dream villa',
      filter: 'Filters',
      sort: 'Sort',
      priceAsc: 'Price: Low to High',
      priceDesc: 'Price: High to Low',
      all: 'All Villas',
    },
    villa: {
      features: 'Features',
      location: 'Location',
      request: 'Request Info',
      gallery: 'Gallery',
      back: 'Back to Catalog',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      area: 'Living Area',
      land: 'Land Area',
      status: 'Status',
      forSale: 'For Sale',
      sold: 'Sold',
      reserved: 'Reserved',
      priceOnRequest: 'Price on request',
    },
    admin: {
      login: 'Admin Login',
      email: 'Email',
      password: 'Password',
      loginBtn: 'Login',
      logout: 'Logout',
      dashboard: 'Dashboard',
      villas: 'Villas',
      contacts: 'Inquiries',
      addVilla: 'Add Villa',
      editVilla: 'Edit Villa',
      deleteVilla: 'Delete Villa',
      save: 'Save',
      cancel: 'Cancel',
      published: 'Published',
      featured: 'Featured',
      noContacts: 'No inquiries',
      markRead: 'Mark as Read',
    },
    seo: {
      homeTitle: 'Seafront Premium Villas — Villa.ooo',
      homeDescription: 'Premium villas in Dalmatia, Croatia. Seafront villas in premium seaside locations. Direct from developer, no fees.',
      catalogTitle: 'Seafront Villas for Sale in Croatia — Villa.ooo',
      catalogDescription: 'Luxury seafront villas for sale in Dalmatia region, Croatia. Trogir, Primosten, Omis. Direct from developer.',
    },
    dalmatia: {
      title: 'Dalmatia — The Pearl of Croatia',
      description: 'Escape to the enchanting Dalmatian Coast of Croatia — a hidden gem of Europe where the azure Adriatic Sea kisses the rugged limestone cliffs.',
    },
  },
  de: {
    nav: {
      home: 'Startseite',
      catalog: 'Villen',
      contact: 'Kontakt',
      admin: 'Admin',
    },
    hero: {
      subtitle: 'Luxusvillen zu verkaufen in Kroatien',
      title: 'Villa in Kroatien kaufen — Direkt am Meer',
      description: 'Möchten Sie eine Strandvilla in Kroatien kaufen? Wir bieten Luxusvillen zu verkaufen direkt vom Bauträger — keine versteckten Gebühren. Häuser zu verkaufen in Dalmatien.',
      cta: 'Villen ansehen',
      ctaSecondary: 'WhatsApp',
    },
    about: {
      label: 'Über uns',
      title: 'Villa in Kroatien kaufen — Ihr Traumhaus wartet',
      description: 'Suchen Sie Häuser zu verkaufen in Kroatien? Unsere Luxusvillen zu verkaufen befinden sich direkt am Meer. Villa in Kroatien kaufen direkt vom Bauträger. Strandvillen mit außergewöhnlichem Lebensstil und starkem Investitionspotenzial.',
      feature1: 'Beste Angebote',
      feature2: 'Bestätigte Qualität',
      feature3: 'Rechtliche Unterstützung',
    },
    villas: {
      label: 'Villen zu verkaufen',
      title: 'Luxusvillen zu verkaufen in Kroatien',
      viewAll: 'Alle ansehen',
      bedrooms: 'Schlafzimmer',
      bathrooms: 'Badezimmer',
      area: 'm²',
      details: 'Details',
      noVillas: 'Villen kommen bald',
    },
    contact: {
      label: 'Kontakt',
      title: 'Kontaktieren Sie uns',
      description: 'Möchten Sie eine Villa in Kroatien kaufen? Wir helfen Ihnen gerne!',
      name: 'Ihr Name',
      email: 'E-Mail',
      phone: 'Telefon',
      message: 'Nachricht',
      send: 'Anfrage senden',
      success: 'Anfrage gesendet!',
      successDesc: 'Wir werden Sie in Kürze kontaktieren',
    },
    footer: {
      rights: 'Alle Rechte vorbehalten',
      privacy: 'Datenschutz',
      seoText: 'Villa in Kroatien kaufen | Villen zu verkaufen in Kroatien | Luxus-Strandimmobilien | Häuser zu verkaufen in Dalmatien',
    },
    features: {
      bestOffers: 'Beste Angebote',
      bestOffersDesc: 'Wir bieten Villen bester Qualität aus natürlichen Materialien mit höchster Energieeffizienz',
      quality: 'Bestätigte Qualität',
      qualityDesc: 'Sie erhalten vollständige Projektdokumentation für volles Vertrauen in die Qualität',
      saveMoney: 'Geld sparen',
      saveMoneyDesc: 'Villa in Kroatien kaufen direkt vom Bauträger zu einem fairen Preis ohne versteckte Gebühren',
      bestPrice: 'Beste Villen zum besten Preis',
      bestPriceDesc: 'Suchen Sie Luxusvillen zu verkaufen in Kroatien? Alle unsere Villen liegen in erster Meereslinie',
      legalSupport: 'Rechtliche Unterstützung',
      legalSupportDesc: 'Wir garantieren absolute Transparenz und volle Einhaltung der EU-Vorschriften',
      businessGain: 'Geschäftsgewinn',
      businessGainDesc: 'Die Villa kann vermietet werden und hohe Einnahmen erzielen',
    },
    catalog: {
      title: 'Villenkatalog',
      subtitle: 'Finden Sie Ihre Traumvilla',
      filter: 'Filter',
      sort: 'Sortieren',
      priceAsc: 'Preis: Niedrig bis Hoch',
      priceDesc: 'Preis: Hoch bis Niedrig',
      all: 'Alle Villen',
    },
    villa: {
      features: 'Ausstattung',
      location: 'Standort',
      request: 'Anfrage stellen',
      gallery: 'Galerie',
      back: 'Zurück zum Katalog',
      bedrooms: 'Schlafzimmer',
      bathrooms: 'Badezimmer',
      area: 'Wohnfläche',
      land: 'Grundstück',
      status: 'Status',
      forSale: 'Zu verkaufen',
      sold: 'Verkauft',
      reserved: 'Reserviert',
      priceOnRequest: 'Preis auf Anfrage',
    },
    admin: {
      login: 'Admin-Anmeldung',
      email: 'E-Mail',
      password: 'Passwort',
      loginBtn: 'Anmelden',
      logout: 'Abmelden',
      dashboard: 'Dashboard',
      villas: 'Villen',
      contacts: 'Anfragen',
      addVilla: 'Villa hinzufügen',
      editVilla: 'Villa bearbeiten',
      deleteVilla: 'Villa löschen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      published: 'Veröffentlicht',
      featured: 'Hervorgehoben',
      noContacts: 'Keine Anfragen',
      markRead: 'Als gelesen markieren',
    },
    seo: {
      homeTitle: 'Villa.ooo — Premium-Villen in erster Meereslinie in Dalmatien, Kroatien',
      homeDescription: 'Premium-Villen in Dalmatien, Kroatien. Villen in erster Meereslinie. Direkt vom Bauträger.',
      catalogTitle: 'Villen zum Verkauf in Kroatien — Villa.ooo',
      catalogDescription: 'Luxusvillen zum Verkauf in Dalmatien, Kroatien. Trogir, Primosten, Omis.',
    },
    dalmatia: {
      title: 'Dalmatien — Die Perle Kroatiens',
      description: 'Entfliehen Sie an die bezaubernde dalmatinische Küste Kroatiens — ein verborgenes Juwel Europas.',
    },
  },
  pl: {
    nav: {
      home: 'Strona główna',
      catalog: 'Wille',
      contact: 'Kontakt',
      admin: 'Admin',
    },
    hero: {
      subtitle: 'Luksusowe wille na sprzedaż w Chorwacji',
      title: 'Kupić willę w Chorwacji — Nad samym morzem',
      description: 'Chcesz kupić willę nad morzem w Chorwacji? Oferujemy luksusowe wille na sprzedaż bezpośrednio od dewelopera — bez ukrytych opłat. Domy na sprzedaż w Dalmacji.',
      cta: 'Zobacz wille na sprzedaż',
      ctaSecondary: 'WhatsApp',
    },
    about: {
      label: 'O nas',
      title: 'Kupić willę w Chorwacji — Twój wymarzony dom czeka',
      description: 'Szukasz domów na sprzedaż w Chorwacji? Nasze luksusowe wille na sprzedaż znajdują się tuż przy morzu. Kup willę nad morzem w Chorwacji bezpośrednio od dewelopera. Wille z wyjątkowym stylem życia i silnym potencjałem inwestycyjnym.',
      feature1: 'Najlepsze oferty',
      feature2: 'Potwierdzona jakość',
      feature3: 'Wsparcie prawne',
    },
    villas: {
      label: 'Wille na sprzedaż',
      title: 'Luksusowe wille na sprzedaż w Chorwacji',
      viewAll: 'Zobacz wszystkie',
      bedrooms: 'sypialnie',
      bathrooms: 'łazienki',
      area: 'm²',
      details: 'Szczegóły',
      noVillas: 'Wille wkrótce',
    },
    contact: {
      label: 'Kontakt',
      title: 'Skontaktuj się z nami',
      description: 'Chcesz kupić willę w Chorwacji? Chętnie pomożemy!',
      name: 'Twoje imię',
      email: 'E-mail',
      phone: 'Telefon',
      message: 'Wiadomość',
      send: 'Wyślij zapytanie',
      success: 'Zapytanie wysłane!',
      successDesc: 'Skontaktujemy się wkrótce',
    },
    footer: {
      rights: 'Wszelkie prawa zastrzeżone',
      privacy: 'Polityka prywatności',
      seoText: 'Kupić willę w Chorwacji | Wille na sprzedaż w Chorwacji | Luksusowe nieruchomości nad morzem | Domy na sprzedaż w Dalmacji',
    },
    features: {
      bestOffers: 'Najlepsze oferty',
      bestOffersDesc: 'Oferujemy wille najwyższej jakości z naturalnych materiałów z najwyższą klasą energetyczną',
      quality: 'Potwierdzona jakość',
      qualityDesc: 'Otrzymujesz pełną dokumentację projektową dla pełnego zaufania do jakości',
      saveMoney: 'Oszczędź pieniądze',
      saveMoneyDesc: 'Kup willę w Chorwacji bezpośrednio od dewelopera po uczciwej cenie bez ukrytych opłat',
      bestPrice: 'Najlepsze wille w najlepszej cenie',
      bestPriceDesc: 'Szukasz luksusowych willi na sprzedaż w Chorwacji? Wszystkie nasze wille są w pierwszej linii brzegowej',
      legalSupport: 'Wsparcie prawne',
      legalSupportDesc: 'Gwarantujemy pełną przejrzystość i zgodność z przepisami UE',
      businessGain: 'Zysk biznesowy',
      businessGainDesc: 'Willę można wynajmować i uzyskiwać wysokie dochody',
    },
    catalog: {
      title: 'Katalog willi',
      subtitle: 'Znajdź willę swoich marzeń',
      filter: 'Filtry',
      sort: 'Sortuj',
      priceAsc: 'Cena: rosnąco',
      priceDesc: 'Cena: malejąco',
      all: 'Wszystkie wille',
    },
    villa: {
      features: 'Cechy',
      location: 'Lokalizacja',
      request: 'Zapytaj o ofertę',
      gallery: 'Galeria',
      back: 'Powrót do katalogu',
      bedrooms: 'Sypialnie',
      bathrooms: 'Łazienki',
      area: 'Powierzchnia mieszkalna',
      land: 'Powierzchnia działki',
      status: 'Status',
      forSale: 'Na sprzedaż',
      sold: 'Sprzedana',
      reserved: 'Zarezerwowana',
      priceOnRequest: 'Cena na zapytanie',
    },
    admin: {
      login: 'Logowanie administratora',
      email: 'E-mail',
      password: 'Hasło',
      loginBtn: 'Zaloguj',
      logout: 'Wyloguj',
      dashboard: 'Panel',
      villas: 'Wille',
      contacts: 'Zapytania',
      addVilla: 'Dodaj willę',
      editVilla: 'Edytuj willę',
      deleteVilla: 'Usuń willę',
      save: 'Zapisz',
      cancel: 'Anuluj',
      published: 'Opublikowano',
      featured: 'Wyróżnione',
      noContacts: 'Brak zapytań',
      markRead: 'Oznacz jako przeczytane',
    },
    seo: {
      homeTitle: 'Villa.ooo — Premium wille w pierwszej linii brzegowej w Dalmacji, Chorwacja',
      homeDescription: 'Premium wille w Dalmacji, Chorwacja. Wille w pierwszej linii brzegowej. Bezpośrednio od dewelopera.',
      catalogTitle: 'Wille na sprzedaż w Chorwacji — Villa.ooo',
      catalogDescription: 'Luksusowe wille na sprzedaż w Dalmacji, Chorwacja. Trogir, Primosten, Omis.',
    },
    dalmatia: {
      title: 'Dalmacja — Perła Chorwacji',
      description: 'Ucieknij na urokliwe wybrzeże dalmatyńskie Chorwacji — ukryty klejnot Europy.',
    },
  },
  sv: {
    nav: {
      home: 'Hem',
      catalog: 'Villor',
      contact: 'Kontakt',
      admin: 'Admin',
    },
    hero: {
      subtitle: 'Lyxvillor till salu i Kroatien',
      title: 'Köpa villa i Kroatien — Direkt vid havet',
      description: 'Vill du köpa en strandvilla i Kroatien? Vi erbjuder lyxvillor till salu direkt från byggherren — inga dolda avgifter. Hus till salu i Dalmatien.',
      cta: 'Se villor till salu',
      ctaSecondary: 'WhatsApp',
    },
    about: {
      label: 'Om oss',
      title: 'Köpa villa i Kroatien — Ditt drömhem väntar',
      description: 'Letar du efter hus till salu i Kroatien? Våra lyxvillor till salu ligger precis vid havet. Köp en havsnära villa i Kroatien direkt från byggherren. Strandvillor med exceptionell livsstil och stark investeringspotential.',
      feature1: 'Bästa erbjudanden',
      feature2: 'Bekräftad kvalitet',
      feature3: 'Juridiskt stöd',
    },
    villas: {
      label: 'Villor till salu',
      title: 'Lyxvillor till salu i Kroatien',
      viewAll: 'Visa alla',
      bedrooms: 'sovrum',
      bathrooms: 'badrum',
      area: 'm²',
      details: 'Detaljer',
      noVillas: 'Villor kommer snart',
    },
    contact: {
      label: 'Kontakt',
      title: 'Kontakta oss',
      description: 'Vill du köpa en villa i Kroatien? Vi hjälper dig gärna!',
      name: 'Ditt namn',
      email: 'E-post',
      phone: 'Telefon',
      message: 'Meddelande',
      send: 'Skicka förfrågan',
      success: 'Förfrågan skickad!',
      successDesc: 'Vi kontaktar dig snart',
    },
    footer: {
      rights: 'Alla rättigheter förbehållna',
      privacy: 'Integritetspolicy',
      seoText: 'Köpa villa i Kroatien | Villor till salu i Kroatien | Lyxiga strandfastigheter | Hus till salu i Dalmatien',
    },
    features: {
      bestOffers: 'Bästa erbjudanden',
      bestOffersDesc: 'Vi erbjuder villor av högsta kvalitet gjorda av naturliga material med högsta energieffektivitet',
      quality: 'Bekräftad kvalitet',
      qualityDesc: 'Du får fullständig projektdokumentation för fullt förtroende för kvaliteten',
      saveMoney: 'Spara pengar',
      saveMoneyDesc: 'Köp villa i Kroatien direkt från byggherren till ett rättvist pris utan dolda avgifter',
      bestPrice: 'Bästa villor till bästa pris',
      bestPriceDesc: 'Letar du efter lyxvillor till salu i Kroatien? Alla våra villor ligger i första linjen',
      legalSupport: 'Juridiskt stöd',
      legalSupportDesc: 'Vi garanterar absolut transparens och full överensstämmelse med EU-regler',
      businessGain: 'Affärsvinst',
      businessGainDesc: 'Villan kan hyras ut och ge hög inkomst',
    },
    catalog: {
      title: 'Villakatalog',
      subtitle: 'Hitta din drömvilla',
      filter: 'Filter',
      sort: 'Sortera',
      priceAsc: 'Pris: Lågt till högt',
      priceDesc: 'Pris: Högt till lågt',
      all: 'Alla villor',
    },
    villa: {
      features: 'Funktioner',
      location: 'Plats',
      request: 'Begär info',
      gallery: 'Galleri',
      back: 'Tillbaka till katalog',
      bedrooms: 'Sovrum',
      bathrooms: 'Badrum',
      area: 'Boarea',
      land: 'Tomtarea',
      status: 'Status',
      forSale: 'Till salu',
      sold: 'Såld',
      reserved: 'Reserverad',
      priceOnRequest: 'Pris på förfrågan',
    },
    admin: {
      login: 'Admin-inloggning',
      email: 'E-post',
      password: 'Lösenord',
      loginBtn: 'Logga in',
      logout: 'Logga ut',
      dashboard: 'Dashboard',
      villas: 'Villor',
      contacts: 'Förfrågningar',
      addVilla: 'Lägg till villa',
      editVilla: 'Redigera villa',
      deleteVilla: 'Ta bort villa',
      save: 'Spara',
      cancel: 'Avbryt',
      published: 'Publicerad',
      featured: 'Utvald',
      noContacts: 'Inga förfrågningar',
      markRead: 'Markera som läst',
    },
    seo: {
      homeTitle: 'Villa.ooo — Premium villor i första linjen i Dalmatien, Kroatien',
      homeDescription: 'Premium villor i Dalmatien, Kroatien. Villor i första linjen vid havet. Direkt från byggherren.',
      catalogTitle: 'Villor till salu i Kroatien — Villa.ooo',
      catalogDescription: 'Lyxvillor till salu i Dalmatien, Kroatien. Trogir, Primosten, Omis.',
    },
    dalmatia: {
      title: 'Dalmatien — Kroatiens pärla',
      description: 'Fly till den förtrollande dalmatinska kusten i Kroatien — en dold juvel i Europa.',
    },
  },
  cs: {
    nav: {
      home: 'Domů',
      catalog: 'Vily',
      contact: 'Kontakt',
      admin: 'Admin',
    },
    hero: {
      subtitle: 'Luxusní vily na prodej v Chorvatsku',
      title: 'Koupit vilu v Chorvatsku — Přímo u moře',
      description: 'Chcete koupit vilu u moře v Chorvatsku? Nabízíme luxusní vily na prodej přímo od developera — žádné skryté poplatky. Domy na prodej v Dalmácii.',
      cta: 'Zobrazit vily na prodej',
      ctaSecondary: 'WhatsApp',
    },
    about: {
      label: 'O nás',
      title: 'Koupit vilu v Chorvatsku — Váš vysněný dům čeká',
      description: 'Hledáte domy na prodej v Chorvatsku? Naše luxusní vily na prodej se nacházejí přímo u moře. Kupte vilu u moře v Chorvatsku přímo od developera. Plážové vily s výjimečným životním stylem a silným investičním potenciálem.',
      feature1: 'Nejlepší nabídky',
      feature2: 'Potvrzená kvalita',
      feature3: 'Právní podpora',
    },
    villas: {
      label: 'Vily na prodej',
      title: 'Luxusní vily na prodej v Chorvatsku',
      viewAll: 'Zobrazit vše',
      bedrooms: 'ložnice',
      bathrooms: 'koupelny',
      area: 'm²',
      details: 'Detaily',
      noVillas: 'Vily brzy',
    },
    contact: {
      label: 'Kontakt',
      title: 'Kontaktujte nás',
      description: 'Chcete koupit vilu v Chorvatsku? Rádi vám pomůžeme!',
      name: 'Vaše jméno',
      email: 'E-mail',
      phone: 'Telefon',
      message: 'Zpráva',
      send: 'Odeslat poptávku',
      success: 'Poptávka odeslána!',
      successDesc: 'Brzy vás budeme kontaktovat',
    },
    footer: {
      rights: 'Všechna práva vyhrazena',
      privacy: 'Zásady ochrany osobních údajů',
      seoText: 'Koupit vilu v Chorvatsku | Vily na prodej v Chorvatsku | Luxusní přímořské nemovitosti | Domy na prodej v Dalmácii',
    },
    features: {
      bestOffers: 'Nejlepší nabídky',
      bestOffersDesc: 'Nabízíme vily nejvyšší kvality z přírodních materiálů s nejvyšší energetickou účinností',
      quality: 'Potvrzená kvalita',
      qualityDesc: 'Obdržíte kompletní projektovou dokumentaci pro plnou důvěru v kvalitu',
      saveMoney: 'Ušetřete peníze',
      saveMoneyDesc: 'Kupte vilu v Chorvatsku přímo od developera za férovou cenu bez skrytých poplatků',
      bestPrice: 'Nejlepší vily za nejlepší cenu',
      bestPriceDesc: 'Hledáte luxusní vily na prodej v Chorvatsku? Všechny naše vily jsou v první linii u moře',
      legalSupport: 'Právní podpora',
      legalSupportDesc: 'Garantujeme absolutní transparentnost a plný soulad s předpisy EU',
      businessGain: 'Obchodní zisk',
      businessGainDesc: 'Vilu lze pronajímat a získávat vysoký příjem',
    },
    catalog: {
      title: 'Katalog vil',
      subtitle: 'Najděte vilu svých snů',
      filter: 'Filtry',
      sort: 'Řadit',
      priceAsc: 'Cena: Od nejnižší',
      priceDesc: 'Cena: Od nejvyšší',
      all: 'Všechny vily',
    },
    villa: {
      features: 'Vlastnosti',
      location: 'Poloha',
      request: 'Požádat o info',
      gallery: 'Galerie',
      back: 'Zpět do katalogu',
      bedrooms: 'Ložnice',
      bathrooms: 'Koupelny',
      area: 'Obytná plocha',
      land: 'Pozemek',
      status: 'Status',
      forSale: 'Na prodej',
      sold: 'Prodáno',
      reserved: 'Rezervováno',
      priceOnRequest: 'Cena na vyžádání',
    },
    admin: {
      login: 'Přihlášení administrátora',
      email: 'E-mail',
      password: 'Heslo',
      loginBtn: 'Přihlásit',
      logout: 'Odhlásit',
      dashboard: 'Panel',
      villas: 'Vily',
      contacts: 'Poptávky',
      addVilla: 'Přidat vilu',
      editVilla: 'Upravit vilu',
      deleteVilla: 'Smazat vilu',
      save: 'Uložit',
      cancel: 'Zrušit',
      published: 'Publikováno',
      featured: 'Doporučené',
      noContacts: 'Žádné poptávky',
      markRead: 'Označit jako přečtené',
    },
    seo: {
      homeTitle: 'Villa.ooo — Prémiové vily v první linii v Dalmácii, Chorvatsko',
      homeDescription: 'Prémiové vily v Dalmácii, Chorvatsko. Vily v první linii u moře. Přímo od developera.',
      catalogTitle: 'Vily na prodej v Chorvatsku — Villa.ooo',
      catalogDescription: 'Luxusní vily na prodej v Dalmácii, Chorvatsko. Trogir, Primosten, Omis.',
    },
    dalmatia: {
      title: 'Dalmácie — Perla Chorvatska',
      description: 'Unikněte na okouzlující dalmatské pobřeží Chorvatska — skrytý klenot Evropy.',
    },
  },
};

const languageNames = {
  en: 'English',
  de: 'Deutsch',
  pl: 'Polski',
  sv: 'Svenska',
  cs: 'Čeština',
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('villa-lang');
    return saved && translations[saved] ? saved : 'en';
  });

  useEffect(() => {
    localStorage.setItem('villa-lang', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const availableLanguages = Object.keys(translations);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, availableLanguages, languageNames }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
